/**
 * Derives a page-state descriptor from the current URL path.
 * Used by HelpButton to attach context to support tickets.
 */

export interface PageState {
  route: string
  entityType: string | null
  entityId: number | string | null
}

const ENTITY_PATTERNS: { type: string; regex: RegExp }[] = [
  { type: 'print', regex: /^\/analyze\/(\d+)/ },
  { type: 'print', regex: /^\/prints\/(\d+)/ },
  { type: 'rfq', regex: /^\/rfq\/([^/]+)/ },
  { type: 'assembly', regex: /^\/assemblies\/(\d+)/ },
  { type: 'customer-formulas', regex: /^\/customers\/(\d+)\/formulas/ },
]

export function getPageState(pathname: string = window.location.pathname): PageState {
  for (const { type, regex } of ENTITY_PATTERNS) {
    const m = pathname.match(regex)
    if (m) {
      const raw = m[1]
      const idNum = Number(raw)
      return {
        route: pathname,
        entityType: type,
        entityId: Number.isFinite(idNum) && /^\d+$/.test(raw) ? idNum : raw,
      }
    }
  }
  return { route: pathname, entityType: null, entityId: null }
}
